export const enum IncidentActionType {
  INSERT = 'insert',
  DELETE = 'delete',
  UPDATE = 'update',
}
